"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const createFromRaw_1 = __importDefault(require("./createFromRaw"));
const createRaw_1 = __importDefault(require("./createRaw"));
const flow_1 = __importDefault(require("lodash/fp/flow"));
__exportStar(require("./types"), exports);
const autocompleteContext = {
    create: flow_1.default(createRaw_1.default, createFromRaw_1.default),
    createFromRaw: createFromRaw_1.default,
    createRaw: createRaw_1.default,
};
exports.default = autocompleteContext;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udGV4dC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQSxvRUFBNEM7QUFDNUMsNERBQW9DO0FBQ3BDLDBEQUFrQztBQUVsQywwQ0FBd0I7QUFFeEIsTUFBTSxtQkFBbUIsR0FBRztJQUMxQixNQUFNLEVBQUUsY0FBSSxDQUFDLG1CQUFTLEVBQUUsdUJBQWEsQ0FBQztJQUN0QyxhQUFhLEVBQWIsdUJBQWE7SUFDYixTQUFTLEVBQVQsbUJBQVM7Q0FDVixDQUFDO0FBRUYsa0JBQWUsbUJBQW1CLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgY3JlYXRlRnJvbVJhdyBmcm9tICcuL2NyZWF0ZUZyb21SYXcnO1xuaW1wb3J0IGNyZWF0ZVJhdyBmcm9tICcuL2NyZWF0ZVJhdyc7XG5pbXBvcnQgZmxvdyBmcm9tICdsb2Rhc2gvZnAvZmxvdyc7XG5cbmV4cG9ydCAqIGZyb20gJy4vdHlwZXMnO1xuXG5jb25zdCBhdXRvY29tcGxldGVDb250ZXh0ID0ge1xuICBjcmVhdGU6IGZsb3coY3JlYXRlUmF3LCBjcmVhdGVGcm9tUmF3KSxcbiAgY3JlYXRlRnJvbVJhdyxcbiAgY3JlYXRlUmF3LFxufTtcblxuZXhwb3J0IGRlZmF1bHQgYXV0b2NvbXBsZXRlQ29udGV4dDtcbiJdfQ==